import Header31 from './Header31'
export default Header31
